<script setup>
import { ref } from 'vue';

// Props
const props = defineProps({
  imageClickable: {
    type: Boolean,
    default: true
  },
  imageFileName: {
    type: String,
    default: null
  },
  rounded: {
    default: "lg"
  },
  size: {
    type: String,
    default: "36"
  },
  cover: {
    type: Boolean,
    default: true
  }
});

// State
const imageOpen = ref(false);
// Computed property for image URLs
const { uploadFilenameToUrl } = useCrudConverters();
// Methods
const handleImageClick = () => {
  if (props.imageClickable) {
    imageOpen.value = true;
  }
};
</script>

<template>
  <v-avatar class="bg-light" :size="size" :rounded="rounded">
    <!-- No photo: whatever the caller puts in the slot (initials), never an empty box. -->
    <slot v-if="!imageFileName"/>
    <v-img
        @click="handleImageClick"
        :cover="cover"
        v-if="imageFileName"
        :src="uploadFilenameToUrl(imageFileName, 'thumbnail')"
    />
    <v-dialog
        fullscreen
        v-if="imageFileName && imageClickable"
        close-on-content-click
        v-model="imageOpen"
        class="pa-5"
    >
      <v-img v-if="imageFileName" :src="uploadFilenameToUrl(imageFileName,'large')" />
    </v-dialog>
  </v-avatar>
</template>

<style scoped>
/* Rounded-square crest look everywhere — never a full circle. Percentage radius
   scales proportionally with the avatar size (≈9px at 36px, ≈16px at 64px). */
.v-avatar {
  border-radius: 26% !important;
}
</style>
